// extracted by mini-css-extract-plugin
export default {"root":"classes_root__xqhZo","form":"classes_form__WmW5H","textarea":"classes_textarea__T-Sph","submit-button":"classes_submit-button__TTfgE"};